import { AnimationProps } from "framer-motion";

export const DEFAULT_MOTION: AnimationProps = {
  transition: { duration: .3 },
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 }
}
